var map = {
	"./01_beyond-doubt.mp3": "2b78",
	"./02_ding.mp3": "ced0",
	"./03_done-for-you.mp3": "bd6b",
	"./04_for-sure.mp3": "88c7",
	"./05_hollow.mp3": "89fe",
	"./06_juntos.mp3": "bef7",
	"./07_maybe-one-day.mp3": "fd70",
	"./08_percussion-sound.mp3": "e9aa",
	"./09_point-blank.mp3": "5c00",
	"./10_swiftly.mp3": "49eb",
	"./11_time-is-now.mp3": "0b45",
	"./12_la_cucaracha_horn.mp3": "9772",
	"./13_samsung_s10_deducion.mp3": "e902"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac03";